import HeroBanner from "@resources/competition/hero-competition.jpg?format=webp&quality=80&width=4000;2560;2000;1600;1024;767;500&as=srcset&imagetools";
import HeroEstate from "@resources/competition/block.jpg?format=webp&quality=80&width=1600;1024;767;500&as=srcset&imagetools";
import { useState, useEffect, useMemo } from "react";

export const HeroCompetition = ({
    withButton = true,
    buttonLink = "#glosowanie",
    buttonText = "Głosowanie",
    heading = "Mural na Kusocińskiego będzie oczyszczał powietrze",
    withDescription = true,
}: {
    withButton?: boolean;
    buttonLink?: string;
    buttonText?: string;
    heading?: string;
    withDescription?: boolean;
}) => {
    const video = "https://www.youtube.com/shorts/u0CbjgbNacQ";

    // Extract video ID using useMemo to avoid recalculation on every render
    const videoId = useMemo(() => {
        const youtubeRegex =
            /(?:youtube\.com\/(?:shorts\/|watch\?v=|embed\/)|youtu\.be\/)([^"&?\/ ]{11})/;
        const match = video.match(youtubeRegex);
        return match ? match[1] : "";
    }, [video]);

    return (
        <div className="min-h-screen lg:pt-[170px] pt-[160px] lg:mt-0 mt-10 flex items-center justify-center relative overflow-hidden">
            <img
                srcSet={HeroBanner}
                alt="Hero"
                className="absolute top-0 w-full h-full object-cover z-0"
            />
            <div className="2xl:px-20 md:px-10 px-4 grid lg:gap-x-20 lg:grid-cols-2 items-center grid-cols-1 relative z-10 lg:py-28">
                <div>
                    <h1 className="lg:text-[60px] lg:leading-[72px] text-h1sm uppercase tracking-[-0.6px] text-primary font-black mb-6">
                        {heading}
                    </h1>
                    {withDescription && (
                        <p className="text-primary text-xl font-semibold mb-8">
                            W październiku 2025 r. na gdańskiej Morenie, przy
                            ul. Kusocińskiego, na ścianach inwestycji
                            mieszkaniowej realizowanej przez Unidevelopment SA
                            powstał mural. Autorką projektu wielkoformatowych
                            grafik jest Michalina Knopińska, studentka Akademii
                            Sztuk Pięknych w Gdańsku. Praca łączy nowoczesną
                            formę z motywami przyrody. Dzieło zostało wykonane
                            przy użyciu innowacyjnej farby antysmogowej, która
                            oczyszcza powietrze z tlenków azotu. Poznaj jego
                            historię powstania
                        </p>
                    )}
                    {/* {withButton && (
                        <a
                            href={buttonLink}
                            className="bg-primary button-primary w-full min-w-[275px] max-w-fit mt-10"
                        >
                            {buttonText}
                        </a>
                    )} */}
                </div>
                {videoId && (
                    <div className="flex justify-center lg:my-0 my-8">
                        <iframe
                            className="w-full max-w-[500px] aspect-[9/16] h-auto"
                            src={`https://www.youtube.com/embed/${videoId}?autoplay=0&mute=0&controls=1&origin=${window.location.origin}`}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
